import React from "react";

export default function Placeholder({ loading, style, children }) {
    return loading ? <span className="placeholder" style={style} /> : children;
}
